module.exports = __webpack_public_path__ + "img/book-primary.8852642d.svg";